module.exports = __webpack_public_path__ + "static/media/package-redemp.8a97d6c6.svg";